var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { HomeworkComment } from "./HomeworkComment";
import React, { useMemo, useState } from "react";
import styled from "styled-components";
import { HomeWorkStatus, ToggleComment } from "../style";
import { FlexBox } from "@brg/ui";
import { useGetHomeWork } from "../../../../../../hooks/api/useGetHomework";
import useCommonProps from "../../../../../../hooks/useCommonProps";
import { useProfile } from "@brg/auth";
import useLocalization from "../../../../../../hooks/useLocalization";
export var BlockWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
export var HomeworkConditionalBlockWrapper = function (_a) {
    var _b, _c;
    var postId = _a.postId, isStudentPost = _a.isStudentPost, moreOffset = _a.moreOffset, children = _a.children, codeBlock = _a.codeBlock;
    var _d = useState(true), isAnswerCommentBlockHidden = _d[0], setIsAnswerCommentBlockHidden = _d[1];
    var _e = useCommonProps(), projectId = _e.projectId, longreadId = _e.longreadId;
    var profile = useProfile();
    var _f = useLocalization(), language = _f.language, t = _f.t;
    var homeWork = useGetHomeWork({
        projectId: projectId,
        themeId: longreadId,
        studentId: profile === null || profile === void 0 ? void 0 : profile.accountId
    }, language, 1, !isStudentPost).homeWork;
    var isMultiHomework = homeWork === null || homeWork === void 0 ? void 0 : homeWork.isMulti;
    var isCommentLock = useMemo(function () { var _a; return Boolean((_a = homeWork === null || homeWork === void 0 ? void 0 : homeWork.approve) === null || _a === void 0 ? void 0 : _a.isApprove) || isMultiHomework; }, [homeWork, isMultiHomework]);
    // 1 - проверена 2 - отклонена 3 - не проверена
    var workStatus = useMemo(function () {
        var _a, _b;
        if (((_a = homeWork === null || homeWork === void 0 ? void 0 : homeWork.approve) === null || _a === void 0 ? void 0 : _a.isApprove) === true)
            return 1;
        if (((_b = homeWork === null || homeWork === void 0 ? void 0 : homeWork.approve) === null || _b === void 0 ? void 0 : _b.isApprove) === false)
            return 2;
        return 0;
    }, [(_b = homeWork === null || homeWork === void 0 ? void 0 : homeWork.approve) === null || _b === void 0 ? void 0 : _b.isApprove]);
    if (!isStudentPost)
        return React.createElement(React.Fragment, null, children);
    return React.createElement(FlexBox, { direction: "column", directionMobile: "column", gy: 24 },
        React.createElement(BlockWrapper, null,
            React.Children.map(children, function (child) {
                if (React.isValidElement(child)) {
                    return React.cloneElement(child, { isCommentLock: isCommentLock });
                }
                return child;
            }),
            !(isMultiHomework && workStatus === 0) && React.createElement(HomeWorkStatus, { codeBlock: codeBlock, moreOffset: moreOffset, workStatus: workStatus }, workStatus === 0
                ? t('lms.homework.homework_not_checked')
                : workStatus === 1
                    ? (((_c = homeWork === null || homeWork === void 0 ? void 0 : homeWork.approve) === null || _c === void 0 ? void 0 : _c.score) ? "".concat(t('lms.homework.homework_applied_with_score'), " ").concat(homeWork.approve.score) : t('lms.homework.homework_applied'))
                    : t('lms.homework.homework_declined'))),
        React.createElement(HomeworkComment, { isCommentLock: isCommentLock, isAnswerCommentBlockHidden: !(profile === null || profile === void 0 ? void 0 : profile.accountId), postId: postId }));
};
var templateObject_1;
//# sourceMappingURL=HomeworkConditionalBlockWrapper.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { HomeworkComment } from "./HomeworkComment";
import React, { useMemo, useState } from "react";
import styled from "styled-components";
import { HomeWorkStatus, ToggleComment } from "../style";
import { FlexBox } from "@brg/ui";
import { useGetHomeWork } from "../../../../../../hooks/api/useGetHomework";
import useCommonProps from "../../../../../../hooks/useCommonProps";
import { useProfile } from "@brg/auth";
import useLocalization from "../../../../../../hooks/useLocalization";
export var BlockWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
export var HomeworkConditionalBlockWrapper = function (_a) {
    var _b, _c;
    var postId = _a.postId, isStudentPost = _a.isStudentPost, moreOffset = _a.moreOffset, children = _a.children, codeBlock = _a.codeBlock;
    var _d = useState(true), isAnswerCommentBlockHidden = _d[0], setIsAnswerCommentBlockHidden = _d[1];
    var _e = useCommonProps(), projectId = _e.projectId, longreadId = _e.longreadId;
    var profile = useProfile();
    var _f = useLocalization(), language = _f.language, t = _f.t;
    var homeWork = useGetHomeWork({
        projectId: projectId,
        themeId: longreadId,
        studentId: profile === null || profile === void 0 ? void 0 : profile.accountId
    }, language, 1, !isStudentPost).homeWork;
    var isMultiHomework = homeWork === null || homeWork === void 0 ? void 0 : homeWork.isMulti;
    var isCommentLock = useMemo(function () { var _a; return Boolean((_a = homeWork === null || homeWork === void 0 ? void 0 : homeWork.approve) === null || _a === void 0 ? void 0 : _a.isApprove) || isMultiHomework; }, [homeWork, isMultiHomework]);
    // 1 - проверена 2 - отклонена 3 - не проверена
    var workStatus = useMemo(function () {
        var _a, _b;
        if (((_a = homeWork === null || homeWork === void 0 ? void 0 : homeWork.approve) === null || _a === void 0 ? void 0 : _a.isApprove) === true)
            return 1;
        if (((_b = homeWork === null || homeWork === void 0 ? void 0 : homeWork.approve) === null || _b === void 0 ? void 0 : _b.isApprove) === false)
            return 2;
        return 0;
    }, [(_b = homeWork === null || homeWork === void 0 ? void 0 : homeWork.approve) === null || _b === void 0 ? void 0 : _b.isApprove]);
    if (!isStudentPost)
        return React.createElement(React.Fragment, null, children);
    return React.createElement(FlexBox, { direction: "column", directionMobile: "column", gy: 24 },
        React.createElement(BlockWrapper, null,
            React.Children.map(children, function (child) {
                if (React.isValidElement(child)) {
                    return React.cloneElement(child, { isCommentLock: isCommentLock });
                }
                return child;
            }),
            !(isMultiHomework && workStatus === 0) && React.createElement(HomeWorkStatus, { codeBlock: codeBlock, moreOffset: moreOffset, workStatus: workStatus }, workStatus === 0
                ? t('lms.homework.homework_not_checked')
                : workStatus === 1
                    ? (((_c = homeWork === null || homeWork === void 0 ? void 0 : homeWork.approve) === null || _c === void 0 ? void 0 : _c.score) ? "".concat(t('lms.homework.homework_applied_with_score'), " ").concat(homeWork.approve.score) : t('lms.homework.homework_applied'))
                    : t('lms.homework.homework_declined'))),
        React.createElement(HomeworkComment, { isCommentLock: isCommentLock, isAnswerCommentBlockHidden: !(profile === null || profile === void 0 ? void 0 : profile.accountId), postId: postId }));
};
var templateObject_1;
//# sourceMappingURL=HomeworkConditionalBlockWrapper.js.map